import React, { useEffect, useState } from "react";
import db from "../../db/index.json";
import ParagraphTag from "../reusebale/Paragraph";
import { LogIn } from "lucide-react";
import { useSelector, useDispatch } from "react-redux"
import BaseUrl from "../../constants/BaseUrl"
import * as DataAction from "../../store/actions/data/DataAction"
import { Link, useNavigate } from "react-router-dom";
import { ShowError, ShowSuccess } from "../../utils/ToasFunction";
import MyLoader from "../reusebale/myLoader";
const Clock = ({ onBack }) => {
  const navigate = useNavigate();
  const { support } = db;
  const { currentShift } = useSelector(
    (state) => state.data
  );
  const dispatch = useDispatch()






  function GetTimeDifference(checkInDate) {
    const checkIn = new Date(checkInDate);
    const now = new Date();

    let diffMs = Math.abs(now - checkIn); // Get absolute difference in milliseconds
    let diffMinutes = Math.floor(diffMs / (1000 * 60)); // Convert to minutes
    let hours = Math.floor(diffMinutes / 60);
    let minutes = diffMinutes % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  }


  function FormatCheckInDate(checkInData) {
    const date = new Date(checkInData);


    const optionsDate = { day: '2-digit', month: 'short' };
    const formattedDate = date.toLocaleDateString('en-GB', optionsDate);


    const optionsTime = { hour: 'numeric', minute: '2-digit', hour12: true };
    const formattedTime = date.toLocaleTimeString('en-US', optionsTime);

    return `${formattedDate} ${formattedTime}`;
  }

  const [loading, setLoadig] = useState(false)
  const CheckoutHandler = () => {
    setLoadig(true)
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      "checkOutDate": new Date()
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${BaseUrl}api/support/updateCheckout/${currentShift?._id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result)
        if (result.status === "Success") {

          setLoadig(false)
          dispatch(DataAction.ShiftCheckOutHandler())
          navigate("/login")
        } else {
          ShowError(result.message)
          setLoadig(false)
        }
      })
      .catch((error) => console.error(error));
  }

  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );

  const CheckinHandler = () => {

    setLoadig(true)
    const newDate = new Date();
    const formattedDate = newDate.toISOString().split('T')[0];
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      "supportStaffId": loginSuccess?.user?._id,
      "browserId": "3679cbba7e5c654",
      "checkInDate": new Date(),
      "shiftDate": String(formattedDate),
      "type": loginSuccess?.user?.type
    });



    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${BaseUrl}api/support/createShift`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          console.log("Fetched shift data:", result.data); // ⬅️ Add this
          ShowSuccess(result.message);
          dispatch(
            DataAction.GetCurrentShiftAction(
              loginSuccess?.user?._id,
              loginSuccess?.token
            )
          );
          setLoadig(false);
        } else {
          ShowError(result.message)
          setLoadig(false)
        }
      })
      .catch((error) => console.error(error));
  }


  return (
    <div className="bg-white rounded-xl mt-6 p-5">
      <ParagraphTag
        content="CHECK IN / CHECK OUT"
        classes="text-darkColor font-popinsSemiBold text-lg"
      />

      {/* Timeline Wrapper */}
      <div className="relative mt-5 flex flex-col items-start pl-6">
        {/* Vertical Line (Passes Through Center) */}
        <div className="absolute left-[6px] top-0 bottom-0 w-[2px] bg-gray-400"></div>

        {/* Check-In */}
        <div className="relative flex items-center mb-3">
          {/* Bullet */}
          <div className="absolute left-[-6px] w-3 h-3 bg-themeColor rounded-full"></div>
          <ParagraphTag
            content="Check In - "
            classes="text-darkColor/70 font-popinsMedium text-base ml-4"
          />
          <ParagraphTag
            content={currentShift?.checkInDate ? FormatCheckInDate(currentShift?.checkInDate) : "N/A"}
            classes="text-darkColor/40 font-popinsMedium text-xs pl-1"
          />
        </div>

        {/* Check-Out */}
        <div className="relative flex items-center">
          {/* Bullet */}
          <div className="absolute left-[-6px] w-3 h-3 bg-red-400 rounded-full"></div>
          <ParagraphTag
            content="Check Out - "
            classes="text-darkColor/70 font-popinsMedium text-base ml-4"
          />
          <ParagraphTag
            content="N/A"
            classes="text-darkColor/40 font-popinsMedium text-xs pl-1"
          />
        </div>
      </div>

      <div className="flex items-center mt-4">
        <ParagraphTag
          content={currentShift?.checkInDate ? GetTimeDifference(currentShift?.checkInDate) : "0"}
          classes="text-darkColor font-popinsSemiBold text-xl"
        />
        <ParagraphTag
          content="Today's Hours"
          classes="text-darkColor/50 font-popinsMedium text-sm pl-2"
        />
      </div>


      <div className="mt-4">
        {
          loading ? <div className="flex">
            <MyLoader />
          </div> : <button onClick={() => {
            if (currentShift?.checkInDate) {
              CheckoutHandler()
            } else {
              CheckinHandler()
            }

          }} className="bg-themeColor flex justify-center items-center rounded-lg px-5 py-3 cursor-pointer">
            <LogIn color="#ffff" size={20} />
            <span className="pl-3 text-white font-popinsMedium">{currentShift?.checkInDate ? "Check Out" : "Check In"}</span>
          </button>
        }

      </div>
    </div>
  );
};

export default Clock;
